module.exports = __webpack_public_path__ + "static/media/wasek-portfolio-portfolio.abe44c36.jpg";